import { OryxGameClient } from "@westpierstudio/core-module-oryx/game";
import { RequestMessage } from "@westpierstudio/core-module-oryx/services/comms/types/BaseTypes";
import { PeriodicInspectionEvent } from "@westpierstudio/core-module-oryx/services/comms/types/PeriodicInspection";
import { GameEventRequestMessage } from "@westpierstudio/core-module-oryx/services/comms/types/Requests";
import { AuthenticateResponseMessage, OpenGameResponseMessage } from "@westpierstudio/core-module-oryx/services/comms/types/Responses";
import { GameEvent, GameRequest } from "servertypes/ServerEvents";
import { OpenGameEvent } from "servertypes/gameevents/OpenGame";
import { InitialSpinEvent } from "servertypes/gameevents/InitialSpin";
import { InitialWheelEvent } from "servertypes/gameevents/Wheel";
import { FreeSpinEvent } from "servertypes/gameevents/FreeSpin";
import { FreeSpinWheelEvent } from "servertypes/gameevents/FreeSpinWheel";
import { SpinErrorEvent } from "servertypes/gameevents/SpinError";
import { Signal } from "type-signals";
import { GenericGameRequestMessage } from "servertypes/requests/GenericGameRequest";

class LuckyWealthCatGameClientSignals {
    openGame = new Signal<(event: OpenGameEvent)=>void>();
    initialSpin = new Signal<(event: InitialSpinEvent)=>void>();
    initialWheel = new Signal<(event: InitialWheelEvent)=>void>();
    freeSpin = new Signal<(event: FreeSpinEvent)=>void>();
    freeSpinWheel = new Signal<(event: FreeSpinWheelEvent)=>void>();
    spinError = new Signal<(event: SpinErrorEvent)=>void>();
    periodicInspection = new Signal<(event: PeriodicInspectionEvent)=>void>();
    activateFreeRoundError = new Signal<(code: number)=>void>();
}

export class LuckyWealthCatGameClient extends OryxGameClient {
    signals = new LuckyWealthCatGameClientSignals();

    handleIncomingGameEvent(gameEvent: GameEventRequestMessage, _triggeringRequest: RequestMessage): void {

        switch (gameEvent.body.event as GameEvent) {
            case GameEvent.OPEN_GAME:
                this.signals.openGame.dispatch(gameEvent);
                break;
            case GameEvent.INITIAL_SPIN:
                this.signals.initialSpin.dispatch(gameEvent);
                break;
            case GameEvent.INITIAL_WHEEL:
                this.signals.initialWheel.dispatch(gameEvent);
                break;
            case GameEvent.FREE_SPIN:
                this.signals.freeSpin.dispatch(gameEvent);
                break;
            case GameEvent.FREE_SPIN_WHEEL:
                this.signals.freeSpinWheel.dispatch(gameEvent);
                break;
            case GameEvent.SPIN_ERROR:
                this.signals.spinError.dispatch(gameEvent);
                break;
            default:
                this.missingHandlerWarning(gameEvent.header.name);
        }
    }

    handlePeriodicInspectionEvent(periodicInspection: PeriodicInspectionEvent): void {
        this.signals.periodicInspection.dispatch(periodicInspection);
    }

    override handleAuthenticate(response: AuthenticateResponseMessage, triggeringRequest: RequestMessage) {
        super.handleAuthenticate(response, triggeringRequest);
        this.sendOpenGameRequest();
    }

    sendNextRequest(type: GameRequest, coinsPerBet: number, coinSize: number, totalBet: number, freeRoundId?: string): void {

        const { comms } = this.services;

        const messageBody: GenericGameRequestMessage["body"] = {
            type,
            freeRoundId,
            data: {
                coinsPerBet,
                coinSize,
                playerBet: totalBet,
            }
        };

        if (messageBody.freeRoundId === undefined) {
            delete messageBody.freeRoundId;
        }

        comms.sendGameActionRequest(messageBody);
    }

    private missingHandlerWarning(event: string): void {
        console.warn(`No handler specified for: `, event);
    }
}